//定义个改变量
const constDefinition = {
    baseUrl: window.abp.url
};

export default constDefinition;
